import React from "react"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@coval/ui"

import { FieldLabel } from "@/components/shared/forms/FieldLabel"

import { WEBSOCKET_TOOLTIPS } from "./tooltips"
import { SAMPLE_RATE_OPTIONS, type WebSocketFieldProps } from "./types"

export const SampleRateFields: React.FC<WebSocketFieldProps> = ({
  metadata,
  onMetadataUpdate,
  disabled = false,
}) => {
  return (
    <div className="space-y-4">
      <h4 className="text-sm font-medium text-coval-text">Sample Rates</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <FieldLabel
            htmlFor="send-sample-rate"
            tooltip={WEBSOCKET_TOOLTIPS.sendSampleRate}
          >
            Send Sample Rate
          </FieldLabel>
          <Select
            value={
              metadata.send_sample_rate_hertz != null
                ? String(metadata.send_sample_rate_hertz)
                : ""
            }
            onValueChange={(value) =>
              onMetadataUpdate({ send_sample_rate_hertz: parseInt(value, 10) })
            }
            disabled={disabled}
          >
            <SelectTrigger id="send-sample-rate" aria-label="Send sample rate">
              <SelectValue placeholder="16,000 Hz (default)" />
            </SelectTrigger>
            <SelectContent>
              {SAMPLE_RATE_OPTIONS.map((opt) => (
                <SelectItem key={String(opt.value)} value={String(opt.value)}>
                  {opt.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <FieldLabel
            htmlFor="receive-sample-rate"
            tooltip={WEBSOCKET_TOOLTIPS.receiveSampleRate}
          >
            Receive Sample Rate
          </FieldLabel>
          <Select
            value={
              metadata.receive_sample_rate_hertz != null
                ? String(metadata.receive_sample_rate_hertz)
                : ""
            }
            onValueChange={(value) =>
              onMetadataUpdate({
                receive_sample_rate_hertz: parseInt(value, 10),
              })
            }
            disabled={disabled}
          >
            <SelectTrigger
              id="receive-sample-rate"
              aria-label="Receive sample rate"
            >
              <SelectValue placeholder="48,000 Hz (default)" />
            </SelectTrigger>
            <SelectContent>
              {SAMPLE_RATE_OPTIONS.map((opt) => (
                <SelectItem key={String(opt.value)} value={String(opt.value)}>
                  {opt.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  )
}
